import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb, Button, Drawer, Modal, Select } from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
    fetchAllVendors,
    getVendors,
} from "../../API  Functions/PurchaseFunctions";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import {
    cashInOutReport,
    getCreditHistory,
    getPosOrderLines,
    posOrders,
} from "../../API  Functions/SessionHistoryFunctions";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import DateFilter from "../../components/ui/DateFilter";
import dayjs from "dayjs";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import i18next from "i18next";
import { toast } from "react-toastify";
import moment, { lang } from "moment";
import { checkPermission } from "../../Utils/permissionHelper";
import PosOrderTable from "../SessionHistory/PosOrdersTable";
import { AddBox } from "@mui/icons-material";
import { Plus } from "lucide-react";
import { getGroupProducts, getProductGroups } from "../../API  Functions/productGroupFunctions";
import ProductGroupTable from "./ProductGroupTable";
import NewGroup_Modal from "./NewGroupModal";

const ProductGroups = () => {
    const { t, i18n } = useTranslation();
    const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
    const [loading, setloading] = useState(false);
    const { Option } = Select;
    const [data, setData] = useState([]);
    const [currentLimit, setCurrentLimit] = useState(10); // Default limit
    const [currentOffset, setCurrentOffset] = useState(0); // Default offset




    const [groups, setGroups] = useState([]);
    const [createOpen, setCreateOpen] = useState(false);

    const company_id = useSelector(
        (state) => state?.login?.user?.result?.company_id
    );
    const isGinne = useSelector(
        (state) => state?.geneLoginReducer?.isGinneLogin
    );

    const [Loading, setLoading] = useState(false);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [drawerLoading, setDrawerLoading] = useState(false);
    const [drawerData, setDrawerData] = useState(null);
    const [orderLines, setOrderLines] = useState([]);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);



    useEffect(() => {
        // if (user_id) {
        console.log("AAFNAHFAFAFBAFBAa");

        GetGroups("", "", "", currentLimit, currentOffset);
        // }
    }, [currentLimit, currentOffset]);


    const GetGroups = async () => {
        const payload = {
            lang: i18n.language === "ar" ? "ar_001" : "en_US",
            company_id: company_id,
            user_id: user_id,
            offset: currentOffset,
            limit: currentLimit,

        };
        try {
            const res1 = await getProductGroups(payload);

            // console.log("res1---->", res1);


            if (res1?.result[0]?.status_code === 200) {
                setGroups(res1?.result[0]?.product_groups);
            } else {
                setGroups([]);
            }
        } catch (error) {
            console.error("Error fetching KPI data:", error);
            setloading(false);
        } finally {
            setloading(false);
        }
    };



    const handleRowClick = async (order) => {
        setDrawerVisible(true);
        setDrawerLoading(true);
        setDrawerData(order);

        // console.log("vdfggv", order);

        try {
            const payload = {
                lang: i18n.language === "ar" ? "ar_001" : "en_US",
                company_id: company_id,
                user_id: user_id,
                group_id: order.id,
            };
            const res = await getGroupProducts(payload);

            // console.log("resresresres---->", res);


            if (res?.result[0]?.status_code === 200) {
                setOrderLines(res?.result[0]?.product_list || []);
            } else {
                setOrderLines([]);
            }
        } catch (error) {
            console.error("Error fetching order lines:", error);
        } finally {
            setDrawerLoading(false);
        }
    };

    const onClose = () => {
        setDrawerVisible(false);
        setOrderLines([]);
    };

    const handleGroupSave = async ({ englishName, arabicName, selectedProducts, group_id }) => {
        try {
            setLoading(true);

            const payload = {
                company_id: company_id,
                user_id: user_id,
                product_ids: selectedProducts,
                ...(group_id
                    ? { group_id }
                    : { name: englishName, name_ar: arabicName }
                ),
            };

            console.log("API Payload:", payload);

            const res = await axiosInstance.post(URLS.CREATE_PRODUCT_GROUP, payload);
            const result = res?.data?.result?.[0];

            if (result?.status === "with same name product group available.") {
                toast.error(t("Group name already exists. Please choose a different name."));
                return;
            }

            if (result?.status_code === 200) {
                toast.success((group_id ? (t("Group updated successfully")) : (t("Group created successfully"))));

                GetGroups()
                setCreateOpen(false);
            } else {
                toast.error(result?.status || "Operation failed");
            }

        } catch (error) {
            console.error("Error saving group:", error);
            toast.error("Something went wrong while saving the group");
        } finally {
            setLoading(false);
        }
    };


    const confirmDelete = (group) => {
        setSelectedGroup(group);
        setShowConfirmModal(true);
    };


    const handleGroupDelete = async (group) => {
        try {
            setLoading(true);

            // console.log("handleRemoveProducts", selectedGroupProducts);

            const payload = {
                company_id: company_id,
                user_id: user_id,
                group_id: group?.id,
                is_delete: true,
            };

            // console.log("API Payload:", payload);

            const res = await axiosInstance.post(URLS.EDIT_GROUP, payload);
            const result = res?.data?.result?.[0];

            if (result?.status_code === 200) {
                toast.success((t("Group removed successfully")));

                GetGroups()
                setShowConfirmModal(false);
            } else {
                toast.error(result?.status || "Failed to remove products from group");
            }
        } catch (error) {
            console.error("Error removing products:", error);
            toast.error("حدث خطأ أثناء إزالة المنتجات من المجموعة");
        } finally {
            setLoading(false);
        }
    };


    const handleEditSave = async (updatedRow) => {
        try {
            setLoading(true);

            // console.log("updatedRowgroup---->", updatedRow);

            const payload = {
                company_id: company_id,
                user_id: user_id,
                group_id: updatedRow?.id,
                is_delete: false,
                name: updatedRow?.name,
                name_ar: updatedRow?.name_ar,
            };

            // console.log("API Payload:", payload);

            const res = await axiosInstance.post(URLS.EDIT_GROUP, payload);
            const result = res?.data?.result?.[0];

            if (result?.status_code === 200) {
                toast.success((t("Group updated successfully")));

                GetGroups()
                setShowConfirmModal(false);
            } else {
                toast.error(result?.status || "Failed to remove products from group");
            }
        } catch (error) {
            console.error("Error removing products:", error);
            toast.error("حدث خطأ أثناء إزالة المنتجات من المجموعة");
        } finally {
            setLoading(false);
        }
    };



    // console.log("Order Lines Response:", orderLines);

    return (
        <>
            <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
                <Navbar heading="Product Groups" />
                <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3 mt-2">
                    <div className="font-extrabold mb-3">

                    </div>

                    <div className=" mt-3">
                        <div className=" flex justify-end mt-3 mx-8">
                            <button
                                className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                                // onClick={() => setCreateOpen(true)}
                                onClick={() => {
                                    if (checkPermission("/pos/orders", isGinne)) {
                                        setCreateOpen(true);
                                    }
                                }}
                            >
                                <Plus
                                    style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                                />

                                <span>{t("Create Groups")}</span>
                            </button>
                        </div>

                        {loading ? (
                            <ShimmerLoader />
                        ) : (
                            <>
                                <ProductGroupTable
                                    additionalData={groups}
                                    pagination={(values) => {
                                        setCurrentLimit(values.limit);
                                        setCurrentOffset(values.offset);
                                        { console.log("Pagination values:", values); }
                                    }}
                                    onRowClick={handleRowClick}
                                    onDelete={confirmDelete}
                                    onSaveEdit={(updatedRow) => {
                                        handleEditSave(updatedRow);
                                    }}
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Drawer */}
            <Drawer
                title={
                    drawerData
                        ? `${t("Group Name")} - ${i18n.language === "ar"
                            ? drawerData?.name_ar || ""
                            : drawerData?.name || ""
                        }`
                        : ""
                }
                placement={i18n.language === "ar" ? "left" : "right"}
                width={500}
                onClose={onClose}
                visible={drawerVisible}
                styles={{
                    header: {
                        color: "#1E3ABA", // Change this to your desired color
                        fontWeight: "bold",
                        fontSize: "20px",
                    },
                }}
            >
                {drawerLoading ? (
                    <div className="space-y-4 p-4">
                        {/* Header Skeleton */}
                        <div className="h-6 bg-gray-200 rounded animate-pulse w-1/2"></div>

                        {/* Summary Skeleton */}
                        <div className="space-y-2">
                            <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
                            <div className="h-4 bg-gray-200 rounded animate-pulse w-2/3"></div>
                            <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div>
                        </div>

                        {/* Product Line Skeletons */}
                        {[1, 2, 3].map((_, idx) => (
                            <div
                                key={idx}
                                className="flex items-center space-x-3 border rounded-lg bg-white p-3 shadow-sm animate-pulse"
                            >
                                <div className="w-10 h-10 bg-gray-200 rounded"></div>
                                <div className="flex-1 space-y-2">
                                    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                                    <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                                </div>
                                <div className="h-4 bg-gray-200 rounded w-10"></div>
                            </div>
                        ))}
                    </div>
                ) : // <LoadingSpinner />
                    // <div>{t("Loading order details...")}</div>
                    drawerData ? (
                        <div className="space-y-4">
                            {/* Order Summary */}
                            <div className="space-y-1 text-sm font-medium">

                                <p>
                                    <strong>{t("Number of Products :")}</strong> {drawerData.no_of_products}
                                </p>
                            </div>

                            {/* Product Lines */}
                            <div>
                                {orderLines.map((line, index) => (
                                    <div
                                        key={index}
                                        className="flex justify-between items-center border rounded-lg bg-white p-2 mb-2 shadow-sm"
                                    >
                                        {/* Image */}
                                        <img
                                            src={line.image_url || "/placeholder.png"}
                                            alt={line.name}
                                            className="w-10 h-10 object-contain rounded"
                                        />

                                        {/* Middle content: Name + Qty x Price */}
                                        <div className="flex flex-col flex-1 mx-2">
                                            <p className="font-semibold text-sm leading-tight">
                                                {line.name}
                                            </p>
                                            <p className="text-xs text-gray-600">
                                                {line.barcode}
                                            </p>
                                            {/* <p className="text-xs text-gray-600">
                                                {line.qty} x {line.price} {line.currency}
                                            </p> */}
                                        </div>

                                        {/* Right: Total price */}
                                        <p className="font-normal whitespace-nowrap text-right">
                                            {("EGP")} {(line.sale_price).toFixed(2)}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <p>{t("no_product_found")}</p>
                    )}
            </Drawer>

            {/* Confirmation Modal */}
            <Modal
                open={showConfirmModal}
                onCancel={() => setShowConfirmModal(false)}
                footer={null}
                centered
                closable={false}
            >
                <div className="text-center p-6">
                    <h3 className="text-lg font-semibold mb-4 text-gray-800">
                        {t("Are you sure you want to delete this group ?")}
                    </h3>
                    <div className="flex justify-center gap-4 mt-6">
                        <button
                            onClick={() => setShowConfirmModal(false)}
                            className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
                        >
                            {t("No")}
                        </button>
                        <button
                            onClick={() => handleGroupDelete(selectedGroup)}  // ✅ fixed line
                            disabled={loading}
                            className="px-6 py-2 rounded-lg bg-[#FF1616] hover:bg-[#e01414] text-white font-semibold"
                        >
                            {loading ? t("Removing...") : t("Yes")}
                        </button>
                    </div>
                </div>
            </Modal>


            {createOpen && (
                <NewGroup_Modal
                    open={createOpen}
                    onClose={() => setCreateOpen(false)}
                    onSave={handleGroupSave}
                />
            )}
        </>
    );
};

export default ProductGroups;
